<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Work experience' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group row">
      <label class="col-12 col-sm-2 col-form-label">{{'Job title' | translate}} *</label>
      <div class="col-12 col-sm-10">
        <input class="form-control" [(ngModel)]="entity.jobTitle" />
        <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'jobTitle')">
          <p>{{'Please fill in a job title' | translate}}</p>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-12 col-sm-2 col-form-label">{{'Company name' | translate}} *</label>
      <div class="col-12 col-sm-10">
        <input class="form-control" [(ngModel)]="entity.companyName" />
        <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'companyName')">
          <p>{{'Please fill in company name' | translate}}</p>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-12 col-sm-2 col-form-label">{{'Company website' | translate}}</label>
      <div class="col-12 col-sm-10">
        <input class="form-control" [(ngModel)]="entity.companyUrl" />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-12 col-sm-2 col-form-label">{{'Location' | translate}} *</label>
      <div class="col-12 col-sm-10">
        <input class="form-control" [(ngModel)]="entity.location" />
        <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'location')">
          <p>{{'Please fill in location' | translate}}</p>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-12 col-sm-12 col-form-label">{{'Period (from / till)' | translate}} *</label>
      <div class="col-12 col-sm-6">
        <input ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" class="form-control" [(ngModel)]="entity.startDate" (click)="startdate.toggle()" #startdate="ngbDatepicker" />
        <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'startDate')">
          <p>{{'Please fill in start date' | translate}}</p>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <input ngbDatepicker [minDate]="minDate" [maxDate]="maxDate" class="form-control" [(ngModel)]="entity.endDate" (click)="enddate.toggle()" #enddate="ngbDatepicker" />
      </div>
    </div>

    <div class="custom-control custom-checkbox">
      <input [(ngModel)]="entity.isCurrent" type="checkbox" class="custom-control-input" id="isCurrent">
      <label class="custom-control-label" for="isCurrent">
        {{'I currently work here' | translate}}
      </label>
    </div>

    <div class="form-group row">
      <label class="col-12 col-sm-2 col-form-label">{{'Job description' | translate}}</label>
      <div class="col-12 col-sm-10">
        <textarea rows="10" class="form-control" [(ngModel)]="entity.description"></textarea>
        <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'description')">
          <p>{{'Please fill in description' | translate}}</p>
        </div>
      </div>
    </div>

    <div class="interests">

      <h3>{{'Field of interest' | translate}}</h3>

      <app-selector-areaofinterests [maxAmount]="maxAmount" [(ngModel)]="entity.areaOfInterests"></app-selector-areaofinterests>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>

